import React, { useRef, useState } from "react";

import ReCAPTCHA from "react-google-recaptcha";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Row } from "antd";

import { LanguageSelector } from "../../components/selectors";
import { tokenFetchRequest } from "../../store/auth/actions";
import { RootState } from "../../store/root_reducer";

import styles from "./styles.module.scss";

export const LoginPage: React.FC = () => {
  const dispatch = useDispatch();

  const { t, i18n } = useTranslation("login_page");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const reCaptchaRef = useRef<ReCAPTCHA>(null);
  const [reCaptchaToken, setReCaptchaToken] = useState("");
  const RECAPTCHA_SITE_ID = process.env.REACT_APP_RECAPTCHA_SITE_ID;

  const handleLogin = () => {
    dispatch(tokenFetchRequest(username, password, reCaptchaToken));
    setPassword("");
    reCaptchaRef.current && reCaptchaRef.current.reset();
  };

  const isLoading = useSelector((state: RootState) => state.Auth.isLoading);
  const submitDisabled = () => {
    const disabled = isLoading || username === "" || password === "";
    if (RECAPTCHA_SITE_ID) {
      return disabled || reCaptchaToken === "";
    }
    return disabled;
  };

  return (
    <Row justify="center" align="middle" className={styles.page}>
      <LanguageSelector />
      <Col className={styles.container}>
        <Form name="basic" layout="vertical" onFinish={handleLogin}>
          <div className={styles.logoContainer}>
            <div className={styles.logo} />
          </div>

          <Form.Item>
            <h2 className={styles.header}>{t("form.title")}</h2>
          </Form.Item>

          <Form.Item>
            <Input
              type="text"
              size="large"
              className={styles.input}
              prefix={<UserOutlined className={styles.icon} />}
              placeholder={t("form.username.placeholder")}
              disabled={isLoading}
              value={username}
              onChange={(event) => setUsername(event.target.value)}
            />
          </Form.Item>

          <Form.Item>
            <Input
              type="password"
              size="large"
              className={styles.input}
              prefix={<LockOutlined className={styles.icon} />}
              placeholder={t("form.password.placeholder")}
              disabled={isLoading}
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </Form.Item>

          {RECAPTCHA_SITE_ID && (
            <Form.Item>
              <ReCAPTCHA
                ref={reCaptchaRef}
                hl={i18n.language}
                sitekey={RECAPTCHA_SITE_ID}
                onChange={(token) => setReCaptchaToken(token || "")}
              />
            </Form.Item>
          )}

          <Form.Item>
            <Button disabled={submitDisabled()} type="primary" htmlType="submit" block className={styles.submit}>
              {t("form.submit-button.text")}
            </Button>
          </Form.Item>

          <Form.Item>
            <div className={styles.browser}>
              {t("form.browser.prefix")}:
              <a href="https://www.google.com/intl/ru/chrome/" rel="noopener noreferrer" target="_blank">
                Google Chrome
              </a>
            </div>
          </Form.Item>
        </Form>
      </Col>
    </Row>
  );
};
